import retrieveComponentRules from 'app/modules/rules/sagas/retrieveComponentRules';
import whitelistEntitiesForRule from 'app/modules/rules/sagas/whitelistEntitiesForRule';
import retrieveRuleValidationAlertEntities from 'app/modules/rules/sagas/retrieveRuleValidationAlertEntities';
import deployShadowRule from 'app/modules/rules/sagas/deployShadowRule';

const sagaRegistry = [
  retrieveComponentRules,
  whitelistEntitiesForRule,
  retrieveRuleValidationAlertEntities,
  deployShadowRule,
];

export default sagaRegistry;
